import { gql, useMutation } from '@apollo/client'
import {
  MutationUserKycCreateArgs,
  MutationUserKycCreatePayload,
} from 'src/generated'

const MUTATION_USER_KYC_CREATE = gql`
  mutation UserKycCreate($input: MutationUserKycCreateInput!) {
    userKycCreate(input: $input) {
      kycVerification {
        id
        url
      }
    }
  }
`

const useUserKycCreateMutation = () => {
  return useMutation<
    { userKycCreate: MutationUserKycCreatePayload },
    MutationUserKycCreateArgs
  >(MUTATION_USER_KYC_CREATE)
}

export default useUserKycCreateMutation
